/**
 * Builds prefixed class names on demand: every property read returns `${prefix}-${property}`, memoized per prefix.
 *
 * The `Record<string, string>` return type is what makes this usable from TypeScript — the Proxy accepts any string
 * property, which an inferred type cannot express.
 */
const getClassPrefixer = (rawPrefix: string): Record<string, string> => {
  const prefix = rawPrefix.replace(/\W+/g, '')
  const cache: Record<string, string> = {}

  return new Proxy(cache, {
    get: (target, prop) => {
      if (typeof prop !== 'string') {
        return ''
      }
      target[prop] ??= `${prefix}-${prop}`
      return target[prop]
    },
  })
}

export default getClassPrefixer
